import React from 'react';
import { ArrowUpRight, BookOpen, Globe2, Loader2, RefreshCw } from 'lucide-react';
import { Modal } from '../../ui/Modal';
import { HONGGUO_BOARDS, rankingTime } from './hongguoRankingsUtils';
import './HongguoAnalysisModal.css';

const PHASE_LABELS = {
  submitting: '正在启动分析', running: '联网分析中', success: '分析完成', failed: '分析未完成',
  unknown: '等待确认提交结果', 'query-error': '查询已暂停', timeout: '等待已暂停',
};

const HongguoAnalysisModal = ({ entry, onClose, onCheck, onReanalyze }) => {
  if (!entry) return null;
  const { selection, phase, job, error, querying } = entry;
  const result = job?.result;
  const pending = phase === 'submitting' || phase === 'running';
  const boardLabel = HONGGUO_BOARDS.find(item => item.key === selection.board)?.label || '红果榜单';
  const verified = result?.searchStatus === 'VERIFIED';

  return (
    <Modal isOpen onClose={onClose} title="爆款分析" width="max-w-3xl" className="hongguo-analysis-modal">
      <article className="hongguo-analysis" aria-busy={pending || querying}>
        <header className="hongguo-analysis-heading">
          <div><h2>{selection.title || job?.title || '当前剧集'}</h2><p>{boardLabel} · 第 {selection.page} 页</p></div>
          <span className="hongguo-analysis-status" role="status">
            {pending || querying ? <Loader2 size={14} className="hongguo-analysis-spinner" /> : <BookOpen size={14} />}
            {querying && !pending ? '查询已有结果' : PHASE_LABELS[phase]}
          </span>
        </header>

        {pending ? <div className="hongguo-analysis-loading">
          <Globe2 size={24} aria-hidden="true" />
          <h3>正在查找公开资料，梳理爆款思路</h3>
          <p>会区分已查证信息与创作推测，不把封面当作正片。</p>
          <p className="hongguo-analysis-fee">使用 ChatGPT 线路2联网分析，会产生模型调用费用</p>
          <p>可以先关闭，重新打开后继续查看这次分析。</p>
        </div> : null}

        {error ? <div className="hongguo-analysis-error" role="alert"><h3>{PHASE_LABELS[phase]}</h3><p>{error}</p>
          {phase === 'unknown' ? <p>提交结果尚未确认。先查询已有任务，避免重复分析。</p> : null}
        </div> : null}

        {result ? <div className="hongguo-analysis-result">
          <div className={`hongguo-analysis-evidence${verified ? ' is-verified' : ''}`}>
            <Globe2 size={15} aria-hidden="true" /><div><strong>{verified ? '已获取联网来源' : '尚未完成联网查证'}</strong>
              <p>{verified ? '检索来源不等于逐条核验；爆款原因与创作方向属于分析推测。' : '以下内容仅供创作推测，不能作为已查证事实。'}封面仅作视觉参考，不代表完整剧情。</p>
            </div>
          </div>
          {result.warning ? <p className="hongguo-analysis-warning">{result.warning}</p> : null}
          {result.summary ? <section><h3>分析摘要</h3><p className="hongguo-analysis-text">{result.summary}</p></section> : null}
          {result.sections.map((section, index) => <section key={index}><h3>{section.title || `分析 ${index + 1}`}</h3><p className="hongguo-analysis-text">{section.content}</p></section>)}
          {result.directions.length ? <section><h3>可借鉴方向 · 创作推测</h3><ol>{result.directions.map((direction, index) => <li key={index}>{direction}</li>)}</ol></section> : null}
          {result.unknowns.length ? <section><h3>尚待查证</h3><ul>{result.unknowns.map((unknown, index) => <li key={index}>{unknown}</li>)}</ul></section> : null}
          {result.rawText ? <details className="hongguo-analysis-raw"><summary>查看原始分析</summary><p className="hongguo-analysis-text">{result.rawText}</p></details> : null}
          <section className="hongguo-analysis-sources"><h3>参考来源</h3>
            {result.sources.length ? <ul>{result.sources.map(source => <li key={source.url}><a href={source.url} target="_blank" rel="noopener noreferrer">{source.title}<ArrowUpRight size={13} aria-hidden="true" /></a></li>)}</ul> : <p>暂无可核对的公开来源。</p>}
          </section>
          <p className="hongguo-analysis-time">分析时间：{rankingTime(result.generatedAt || job?.completedAt)}{result.sourceFetchedAt ? ` · 榜单数据：${rankingTime(result.sourceFetchedAt)}` : ''}</p>
        </div> : null}

        <footer className="hongguo-analysis-actions">
          <button type="button" onClick={onClose}>关闭</button>
          {!pending && phase !== 'success' && entry.requestId ? <button type="button" onClick={onCheck} disabled={querying}><RefreshCw size={14} />{querying ? '查询中…' : '查询已有结果'}</button> : null}
          {!pending ? <button type="button" onClick={onReanalyze} disabled={querying} className="hongguo-analysis-primary"><RefreshCw size={14} />重新分析</button> : null}
        </footer>
      </article>
    </Modal>
  );
};

export default HongguoAnalysisModal;
